import { validNumberFromGet } from "./functionFromExport.js";
export {
  getPlatform,
  getWebApp,
  getTelegramWebApp,
  getChatId,
  getInitData,
  getBotLink,
  getSupportBotLink,
  getMessengerName,
  showBackButton,
  hideBackButton,
  onBackButton,
  requestFullscreenSafe,
  onFullscreenChanged,
  ensurePlatformAccess,
  openExternalLink,
  loadRuntimeConfig,
} from "./platform.js";

const normalizeStored = (value) => {
  if (value === null || value === undefined) return null;
  if (value === "n/a") return null;
  return value;
};

export const getStoredPhone = () => {
  const phone = normalizeStored(localStorage.getItem("phoneNumber"));
  if (!phone) return null;
  return validNumberFromGet(phone);
};

export const getStoredGroupId = () => {
  const groupId = normalizeStored(localStorage.getItem("clientGroupId"));
  if (!groupId) return null;
  return groupId.replace(/\s/g, "");
};
